import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const reactPlugin = new ReactPlugin();
const instrumentationKey = import.meta.env.VITE_INSIGHTS_INSTRUMENTATION_KEY;

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: instrumentationKey || "disabled",
    disableTelemetry: !instrumentationKey,
    extensions: [reactPlugin],
  },
});

if (instrumentationKey) {
  appInsights.loadAppInsights();
}

const useTrackPageViews = () => {
  const location = useLocation();

  useEffect(() => {
    if (instrumentationKey) {
      appInsights.trackPageView({ name: location.pathname });
    }
  }, [location]);
};

export { appInsights, reactPlugin, useTrackPageViews };
